import { connect } from 'react-redux';
import PersonalIdentification from '../../components/checkout/PersonalIdentification/PersonalIdentification';

const getIdType = (state) => {
  if (state.form.checkout.values
    && state.form.checkout.values.creditAssessment
    && state.form.checkout.values.creditAssessment.personalIdentificationType) {
    return state.form.checkout.values.creditAssessment.personalIdentificationType;
  }
  return undefined;
};

const mapStateToProps = state => ({
  personalIdentificationType: getIdType(state)
});

const PersonalIdentificationContainer = connect(mapStateToProps)(PersonalIdentification);
export default PersonalIdentificationContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/PersonalIdentificationContainer.js
 **/